import { createFileRoute } from '@tanstack/react-router'
import { NetworkOperationsDashboard } from '@/components/dashboard/NetworkOperationsDashboard'

interface ChatSearch {
  q?: string
}

export const Route = createFileRoute('/_app/chat/$id')({
  validateSearch: (search: Record<string, unknown>): ChatSearch => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
  }),
  component: ChatDashboardPage,
})

function ChatDashboardPage() {
  return <NetworkOperationsDashboard />
}
